import http from '../../HttpConfig'
import {APIS_ENDPOINTS} from '../../SERVICE-CONSTANTS'

const ZamenCheques_endpoints = APIS_ENDPOINTS.requestzamencheques

export interface IZamenChequesCountPayload {
  id?: number
  amount: number
  date: string
  requestId: number
  number: number
  IFile: File
  chequesType: number
}

export const request_sendzamenchequescount = async (data: IZamenChequesCountPayload) => {
  const formData = new FormData()

  if (data.id !== undefined) formData.append('Id', data.id.toString())
  formData.append('Amount', data.amount.toString())
  formData.append('Date', data.date)
  formData.append('RequestId', data.requestId.toString())
  if (data.number) {
    formData.append('Number', data.number.toString())
  }
  if (data.IFile) {
    formData.append('IFile', data.IFile)
  }
  formData.append('ChequesType', data.chequesType.toString())

  return http.post(ZamenCheques_endpoints.sendzamencheques, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const request_getallrequestzamencheques = async ({RequestId}: {RequestId: number}) => {
  return http.get(ZamenCheques_endpoints.getallrequestzamencheques + '?RequestId=' + RequestId)
}

export const request_delete = async ({id}: {id: number}) => {
  return http.delete(ZamenCheques_endpoints.delete + '?id=' + id)
}

export const request_getAllRequestZamenChequesAdmin = async ({
  search,
  CurrentPage,
  PageSize,
}: {
  search?: string
  CurrentPage: number
  PageSize: number
}) => {
  return http.get(
    ZamenCheques_endpoints.getallrequestzamenchequesadmin +
    `?CurrentPage=${CurrentPage}&PageSize=${PageSize}${search ? `&search=${search}` : ''}`
  )
}
